module.exports = __webpack_public_path__ + "static/media/caret-left.6f791327.svg";